const DEFAULT_LANGUAGE = 'es-ES';
const PREFERRED_LANGUAGE_STORAGE_KEY = 'preferredLanguage';
const SUPPORTED_LANGUAGES = ['es-ES', 'en-US'] as const;

type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

function normalizeLanguage(value: unknown): SupportedLanguage | null {
  if (typeof value !== 'string') {
    return null;
  }
  const normalized = value.trim().replace('_', '-').toLowerCase();
  if (normalized === 'es-es' || normalized === 'es') {
    return 'es-ES';
  }
  if (normalized === 'en-us' || normalized === 'en') {
    return 'en-US';
  }
  return null;
}

export function getSupportedLanguages(): ReadonlyArray<SupportedLanguage> {
  return SUPPORTED_LANGUAGES;
}

export function getDefaultLanguage(): SupportedLanguage {
  return DEFAULT_LANGUAGE;
}

export function getCurrentPreferredLanguage(): SupportedLanguage {
  try {
    const stored = localStorage.getItem(PREFERRED_LANGUAGE_STORAGE_KEY);
    const fromStorage = normalizeLanguage(stored);
    if (fromStorage) {
      return fromStorage;
    }
  } catch {
    // no-op
  }

  if (typeof navigator !== 'undefined') {
    const fromNavigator = normalizeLanguage(navigator.language);
    if (fromNavigator) {
      return fromNavigator;
    }
  }

  return DEFAULT_LANGUAGE;
}

export function setPreferredLanguage(value: unknown): SupportedLanguage | null {
  const language = normalizeLanguage(value);
  if (!language) {
    return null;
  }

  try {
    localStorage.setItem(PREFERRED_LANGUAGE_STORAGE_KEY, language);
  } catch {
    // no-op
  }

  return language;
}
